import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { round_group_staff_info, round_group_add_staff } from 'api/Attendance';
import { getAvatar } from '@/util/util';
export default {
  data: function data() {
    return {
      selectAll: false,
      // 是否全选
      // isIndeterminate: false,
      visible: false,
      btnLoad: false,
      // 提交loading
      getAvatar: getAvatar,
      // 名称生成
      searchKeyword: '',
      // 人员搜索
      loading: false,
      disabledPersons: [],
      // 禁选人员
      checkList: [],
      // 已选人员
      allPersons: [],
      // 全部列表
      resultCheckList: [],
      // 搜索结果选中项
      searchResultList: [],
      // 搜索结果列表
      form: {} // 回传数据
    };
  },

  computed: {
    isIndeterminate: function isIndeterminate() {
      var state = this.handleData();
      return !state.isAll && state.isSome;
    }
  },
  methods: {
    init: function init(form) {
      this.visible = true;
      this.form = form;
      this.requestPersonAll(form);
    },
    // 获取所有数据
    requestPersonAll: function requestPersonAll(form) {
      var _this = this;
      this.loading = true;
      round_group_staff_info(form).then(function (res) {
        // 全部人员
        _this.allPersons = res.data.all;
        // 默认选中项
        _this.$nextTick(function () {
          _this.handlerChangeSearch();
          _this.handlerDefaultSelected();
        });
      }).finally(function () {
        return _this.loading = false;
      });
    },
    // 默认选中项
    handlerDefaultSelected: function handlerDefaultSelected() {
      var _this2 = this;
      this.checkList = [];
      this.searchResultList.forEach(function (item) {
        if (item.is_selected === 1) _this2.checkList.push(item);
      });
    },
    // 人员搜索
    handlerChangeSearch: function handlerChangeSearch() {
      var _this3 = this;
      if (!this.searchKeyword) {
        this.searchResultList = this.allPersons;
        return;
      }
      this.searchResultList = [];
      var name = this.allPersons.filter(function (item) {
        return item.staff_name.indexOf(_this3.searchKeyword) !== -1;
      });
      var code = this.allPersons.filter(function (item) {
        return item.staff_code.indexOf(_this3.searchKeyword) !== -1;
      });
      var mobile = this.allPersons.filter(function (item) {
        return item.mobile.indexOf(_this3.searchKeyword) !== -1;
      });
      var list = _toConsumableArray(new Set([].concat(_toConsumableArray(name), _toConsumableArray(mobile), _toConsumableArray(code))));
      this.searchResultList = list;
    },
    // 所有数据列表全选
    handlerAllSelect: function handlerAllSelect(val) {
      var checkList = val ? _toConsumableArray(new Set([].concat(_toConsumableArray(this.searchResultList), _toConsumableArray(this.checkList)))) : [];
      var data = checkList.filter(function (item) {
        return item.is_selected !== 2;
      });
      this.checkList = data;
    },
    // 判断全选状态
    handleData: function handleData() {
      var checkObj = {};
      this.checkList.forEach(function (item) {
        checkObj[item.staff_id] = item;
      });
      var data = this.searchResultList.filter(function (item) {
        return item.is_selected !== 2;
      });
      var state = data.every(function (item) {
        return checkObj[item.staff_id];
      });
      var state1 = data.some(function (item) {
        return checkObj[item.staff_id];
      });
      this.selectAll = state1;
      return {
        isAll: state,
        isSome: state1
      };
    },
    // 删除
    handlerDel: function handlerDel(item, index) {
      if (this.searchKeyword) {
        var ind = this.searchResultList.findIndex(function (i) {
          return i.staff_id === item.staff_id;
        });
        this.searchResultList.splice(ind, 1);
        if (!this.searchResultList.length) this.searchResultList = this.allPersons;
      }
      this.checkList.splice(index, 1);
    },
    doSubmint: function doSubmint() {
      var _this4 = this;
      this.form.staff_ids = this.checkList.map(function (item) {
        return item.staff_id;
      });
      this.btnLoad = true;
      round_group_add_staff(this.form).then(function (res) {
        _this4.$emit('update');
        _this4.visible = false;
      }).finally(function () {
        return _this4.btnLoad = false;
      });
    }
  }
};